const FEATURE_NAME = 'organization-template';

export const organizationTemplateQueryKeyMap = {
  templates: () => [FEATURE_NAME, 'list'],
  templatesWithPagination: (params?: object) =>
    ['/api/organizations/templates/list-with-pagination', params].filter(
      (item) => item !== undefined,
    ),
  template: (id?: string) => [FEATURE_NAME, id],
};

export const organizationTemplateInvalidateQueryKeyMap = {
  updateTemplateList: (id?: string) => [
    organizationTemplateQueryKeyMap.templates(),
    organizationTemplateQueryKeyMap.templatesWithPagination(),
    organizationTemplateQueryKeyMap.template(id),
  ],
};
